import { useState } from "react";
import { Field, Label, Switch } from "@headlessui/react";
import PerformanceIcon from "../../../../assets/PerformanceIcon";
import {
	DistrictCreateEditModel,
	useUpdateReportSettingForDistrictMutation,
} from "../../districtsApiSlice";

interface DistrictReportsSettingProps {
	districtInfo: DistrictCreateEditModel;
	setErrorMessage: (message: string) => void;
}

export default function DistrictReportsSetting({
	districtInfo,
	setErrorMessage,
}: DistrictReportsSettingProps) {
	const [enabled, setEnabled] = useState(districtInfo.isIncludedInReports);

	const [callUpdate] = useUpdateReportSettingForDistrictMutation();

	function handleChange() {
		callUpdate({ districtId: districtInfo.id, enabled: !enabled })
			.unwrap()
			.then(() => {
				setEnabled(!enabled);
			})
			.catch((error) => {
				setErrorMessage(`Failed to save the include in reports setting. ${error.data}`);
			});
	}

	return (
		<div className="flex items-center">
			<PerformanceIcon className="size-18" />
			<div className="ml-4">
				<p>Include In Reports</p>
				<div className="mt-1">
					<Field className="flex items-center ml-2">
						<Label className="sr-only">Include In Reports Toggle</Label>
						<Switch
							checked={enabled}
							onChange={handleChange}
							name="includeInReports"
							className="group relative inline-flex h-7 w-12 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 data-[checked]:bg-primary-600">
							<span
								aria-hidden="true"
								className="pointer-events-none inline-block size-6 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
							/>
						</Switch>
					</Field>
				</div>
			</div>
		</div>
	);
}
